import { useMemo } from 'react'

const CATEGORY_ORDER = ['orientation', 'interest', 'personality', 'eq']

export const useSuperProfileCards = superProfile => {
	return useMemo(
		() =>
			CATEGORY_ORDER.map(cat => ({
				key: cat,
				categoryLabel: superProfile?.[cat]?.categoryLabel || cat,
				archetypeName: superProfile?.[cat]?.label?.name || '—',
			})),
		[superProfile],
	)
}

export default useSuperProfileCards

